
export const logEmailLogin = (axiosInstance, orderId, loginData, isSuccess) => {
      try {
        axiosInstance.post(
          `/authenticate/email/login`,
          {
            orderId,
            loginData,
            isSuccess
          },
        );

        
      } catch (error) {
        console.error(error);
      }
    };

export const logPhoneNumberLogin = (axiosInstance, orderId, loginData, isSuccess) => {
  try {
    axiosInstance.post(
      `/authenticate/phone/login`,
      {
        orderId,
        loginData,
        isSuccess
      },
    );

    
  } catch (error) {
    console.error(error);
  }
};

